(() => {
	$(() => {
		// Base code used on all pages
		base()

		// Homepage code
		homepage();

		// Subpage code
		subpage();

		// Modules code (modules might be used outside of subpage)
		moduleAccordion();
		moduleResponsiveImage();
	});
})();
